'use client';

import Link from 'next/link';
import { t } from '@/i18n/translations';

export function ErrorPage({ lang, _error, reset }) {
    const tx = t(lang, 'common').error;
    const ui = t(lang, 'staticPagesUi').error;
    const homeUrl = `/${lang}`;

    return (
        <section className="nf-wrap">
            <div className="nf">
                <p className="nf-kick">{ui.kicker}</p>

                <h1>{tx.title}</h1>

                <p className="nf-lead">{tx.description}</p>

                <div className="nf-acts">
                    <button className="pri" onClick={() => reset()}>{tx.retry}</button>
                    <Link className="sec" href={homeUrl}>{tx.goHome}</Link>
                </div>

                <div className="nf-pop">
                    <span className="lbl">{ui.popularLabel}</span>
                    <div className="nf-links">
                        {/* было Блог / пустые Таблицы / Контакты — ни одного пути к деньгам (обход 01.10.2026);
                            аренда авто в Черногории — 76% дохода */}
                        <Link href={`${homeUrl}/montenegro/transport`}>{ui.carRental}</Link>
                        <Link href={`${homeUrl}/montenegro/esim`}>{ui.esim}</Link>
                        <Link href={`${homeUrl}/montenegro/tours`}>{ui.tours}</Link>
                        <Link href={`${homeUrl}/blog`}>{ui.blog}</Link>
                    </div>
                </div>
            </div>
        </section>
    );
}
